import React, { Component } from 'react';
import { Row, Col, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label } from 'reactstrap';
import CompanyContext from '../../auth/CompanyContext';
import { Prompt } from 'react-router-dom';

class Groupings extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);

        this.actions = [
            { value: 1, label: 'Add to Favorites' },
            { value: 2, label: 'Add to Ad-Hoc Group' },
            // { value: 3, label: 'Add to Email Campaign' },
            // { value: 4, label: 'Add to Call Campaign' },
            // { value: 5, label: 'Add to Invitation Campaign' },
            { value: 6, label: 'Add Campaign' },
        ]

        this.newGroup = {
            name: '',
            description: '',
            private: false
        }

        this.blankMarketingActivity = {
            id: 0,
            campaignID: 0,
            category: '',
            activityID: 0,
            contactLinkedID: '',
            auth0: this.props.user,
            message: '',
            subject: '',
            to: '',
            sentTimestamp: null,
            attachments: []
        }

        // this.blankMarketing2Campaign = {
        //     Active: false, 
        //     Auth0: this.props.user,
        //     CampaignID: 0,
        //     Components: [],
        //     Description: '',
        //     EndDate: '',
        //     Name: '',
        //     StartDate: ''
        // }

        this.state = {
            selectedAction: 0,
            showModal: false,
            groups: [],
            // marketingCampaigns: [],
            marketing2Campaigns: [],
            users: [],
            emails: [],
            calls: [],
            invitations: [],
            selectedGroup: -1,
            selectedMarketingActivity: { ...this.blankMarketingActivity },
            selectedMarketing2CampaignID: 0,// { ...this.blankMarketing2Campaign },
            newGroup: { ...this.newGroup }
        };

    }

    componentDidMount = () => {
        // this.getUsers();
        // // this.getMarketingCampaigns();
        // this.getMarketing2Campaigns();
    }

    getGroups = () => {
        fetch('/api/groupings/0/' + this.props.user, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState((prevState, props) => {
                    return {
                        groups: results.data
                    };
                });
            });
    }

    getMarketing2Campaigns = (cb) => {
        fetch('/api/marketing2Campaigns/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    marketing2Campaigns: results.data,
                }, () => {
                    if (cb != null) cb();
                });
            });
    }

    getUsers = () => {
        // console.log('Groupings.js/getUsers()');
        fetch('/api/users/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    users: results.data
                });
            });
    }

    onNewGroupChange = (e) => {
        e.persist();
        this.setState((prevState) => {
            let obj = { ...prevState };
            obj.newGroup[e.target.name] = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
            return obj;
        })
    }

    handleApplyToSelected = () => {
        switch (this.state.selectedAction) {
            case 1:
                this.props.selected.forEach(company => {
                    this.props.addFavorite('sec', company, this.props.favoriteCallback)
                })
                this.props.changeSelected();
                break;
            case 2:
                this.getGroups();
                break;
            default:

        }
        this.setState({
            newGroup: { ...this.newGroup },
            showModal: this.state.selectedAction > 1 ? true : false
        })
    }

    handleGroupSave = () => {
        switch (this.state.selectedGroup) {
            case 0:
                fetch('/api/groupings/', {
                    method: 'POST',
                    body: JSON.stringify({
                        grouping: this.state.newGroup.name,
                        description: this.state.newGroup.description,
                        auth0: this.props.user,
                        private: this.state.private,
                        companies: this.props.selected
                    }),
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.props.clientToken,
                        'X-Database': this.context.company
                    }
                })
                    .then(results => results.json())
                    .then(results => {
                        if (results.success) {
                            this.setState({
                                newGroup: { ...this.newGroup },
                                selectedGroup: -1,
                                showModal: false
                            }, () => {
                                this.props.changeSelected();
                                this.getGroups();
                            })
                        }
                        //   if ("callback" in this.props) this.props.callback();
                    });
                break;
            default:
                const group = this.state.groups.filter(group => group.ID === this.state.selectedGroup)[0];
                let companies = [...group.Companies].map(company => company['SEC#']);
                this.props.selected.forEach(company => {
                    let index = companies.findIndex(i => i === company);
                    if (index === -1) {
                        companies.push(company);
                    }
                })
                fetch('/api/groupings/' + this.state.selectedGroup, {
                    method: 'PUT',
                    body: JSON.stringify({
                        grouping: group.Grouping,
                        description: group.Description,
                        auth0: group.Auth0,
                        private: group.Private,
                        companies: companies
                    }),
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.props.clientToken,
                        'X-Database': this.context.company
                    }
                })
                    .then(results => results.json())
                    .then(results => {
                        if (results.success) {
                            this.setState({
                                newGroup: { ...this.newGroup },
                                selectedGroup: -1,
                                showModal: false
                            }, () => {
                                this.props.changeSelected();
                                this.getGroups();
                            })
                        }
                        //   if ("callback" in this.props) this.props.callback();
                    });
        }
    }

    handleCampaign2Save = () => {
        let counter = 0;
        this.props.selected.forEach(secID => {
            fetch('/api/marketing2CampaignsCompanies/', {
                method: 'POST',
                body: JSON.stringify({
                    campaignID: this.state.selectedMarketing2CampaignID,
                    secID: secID,
                    order: 10,
                    auth0: this.state.selectedMarketingActivity.auth0,
                    startDate: new Date().toISOString().substring(0, 10),
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken,
                    'X-Database': this.context.company
                }
            })
                .then(results => results.json())
                .then(results => {
                    if (results.success) {
                        counter++;
                        this.setState({
                            selectedMarketingCampaignID: 0,
                        }, () => {
                            if (counter === this.props.selected.length) {
                                this.setState({
                                    selectedMarketingCampaignID: 0,
                                    showModal: false
                                }, this.props.changeSelected)
                            }
                        });
                    }
                });
        })
    }


    getCampaignType = () => {
        switch (this.state.selectedAction) {
            case 3: return "emails";
            case 4: return "calls";
            case 5: return "invitations";
            default: return null;
        }
    }

    onChangeMarketing2Campaign = (e) => {
        e.persist();
        this.setState({
            selectedMarketing2CampaignID: e.target.value
        })
        // this.setState(prevState => {
        //     let obj = { ...prevState };
        //     obj.selectedMarketing2Campaign = this.getCampaignType();
        //     return obj;
        // })
    }

    onChangeMarketingActivity = (e) => {
        e.persist();
        this.setState(prevState => {
            let obj = { ...prevState };
            obj.selectedMarketingActivity.category = this.getCampaignType();
            obj.selectedMarketingActivity[e.target.name] = e.target.value;
            if (parseInt(obj.selectedMarketingActivity.activityID) > 0) {
                const activity = this.state[this.getCampaignType()].filter(item => item.ID === parseInt(obj.selectedMarketingActivity.activityID))[0];
                obj.selectedMarketingActivity.subject = activity.Subject;
                obj.selectedMarketingActivity.message = activity.Text;
                obj.selectedMarketingActivity.attachments = activity.Attachments != null ? [...JSON.parse(activity.Attachments)] : null;
            }
            return obj;
        })
    }

    render() {
        return (
            <>
                <Prompt
                    when={this.props.selected.length > 0}
                    message="You have unsaved changes, are you sure you want to leave?"
                />
                <Modal isOpen={this.state.showModal}>
                    <ModalHeader >
                        {this.state.selectedAction > 0 && this.actions.filter(action => action.value === this.state.selectedAction)[0].label}
                    </ModalHeader>
                    {/* CampaignNew  */}
                    {this.state.selectedAction === 6 && <>
                        <ModalBody>
                            <Row className='mb-3'>
                                <Col>
                                    <Label>Campaign</Label>
                                    <Input
                                        type="select"
                                        name="campaignID"
                                        // disabled={this.state.editMarketingActivity.sentTimestamp != null}
                                        onChange={this.onChangeMarketing2Campaign}
                                        value={this.state.selectedMarketing2CampaignID}
                                    >
                                        {this.state.marketing2Campaigns.length > 1 && <option value={0}>Select</option>}
                                        {this.state.marketing2Campaigns.map(campaign => (
                                            <option key={campaign.campaignID} value={campaign.campaignID}>{campaign.name}</option>
                                        ))}
                                    </Input>
                                </Col>
                            </Row>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="secondary"
                                onClick={() => this.setState({ showModal: false })}
                            >
                                Cancel
                            </Button>
                            <Button
                                color="primary"
                                disabled={parseInt(this.state.selectedMarketing2CampaignID) === 0}
                                onClick={this.handleCampaign2Save}
                            >
                                Save
                            </Button>
                        </ModalFooter>
                    </>
                    }
                    {/* CampaignOld  */}
                    {/* {this.state.selectedAction >= 3 && this.state.selectedAction <= 5 && <>
                        <ModalBody>
                            <Row className='mb-3'>
                                <Col>
                                    <Label>Campaign</Label>
                                    <Input
                                        type="select"
                                        name="campaignID"
                                        // disabled={this.state.editMarketingActivity.sentTimestamp != null}
                                        onChange={this.onChangeMarketingActivity}
                                        value={this.state.selectedMarketingActivity.campaignID}
                                    >
                                        {this.state.marketingCampaigns.length > 1 && <option value={0}>Select</option>}
                                        {this.state.marketingCampaigns.map(campaign => (
                                            <option key={campaign.ID} value={campaign.ID}>{campaign.Campaign}</option>
                                        ))}
                                    </Input>
                                </Col>
                            </Row>
                            <Row className='mb-3'>
                                <Col>
                                    <Label>Activity</Label>
                                    <Input
                                        type="select"
                                        name="activityID"
                                        // disabled={this.state.editMarketingActivity.sentTimestamp != null}
                                        onChange={this.onChangeMarketingActivity}
                                        value={this.state.selectedMarketingActivity.activityID}
                                    >
                                        {this.state[this.getCampaignType()].length > 1 && <option value={0}>Select</option>}
                                        {this.state[this.getCampaignType()].map(activity => (
                                            <option key={activity.ID} value={activity.ID}>{activity.Name}</option>
                                        ))}
                                    </Input>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="mb-3">
                                    {this.state.users != null && this.state.users.length > 0 && <>
                                        <Label>From (optional)</Label>
                                        <Input
                                            type="select"
                                            name="auth0"
                                            onChange={this.onChangeMarketingActivity}
                                            value={this.state.selectedMarketingActivity.auth0}
                                        >
                                            <option value=''>Sender</option>
                                            {this.state.users.filter(user => user.Active).map(user => (
                                                <option key={user.Auth0} value={user.Auth0}>{user['First Name']} {user['Last Name']}</option>
                                            ))}
                                        </Input>
                                    </>}
                                </Col>
                            </Row>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="secondary"
                                onClick={() => this.setState({ showModal: false })}
                            >
                                Cancel
                            </Button>
                            <Button
                                color="primary"
                                disabled={parseInt(this.state.selectedMarketingActivity.activityID) === 0}
                                onClick={this.handleCampaignSave}
                            >
                                Save
                            </Button>
                        </ModalFooter>
                    </>
                    } */}
                    {/* Ad-Hoc Group */}
                    {this.state.selectedAction === 2 && <>
                        <ModalBody>
                            <Row className='mb-3'>
                                <Col>
                                    <FormGroup>
                                        <Label>Group</Label>
                                    </FormGroup>
                                    <Input
                                        type="select"
                                        onChange={e => this.setState({ selectedGroup: parseInt(e.target.value), newGroup: { ...this.newGroup } })}
                                        value={this.state.selectedGroup}
                                    >
                                        <option value={-1}>Group</option>
                                        <option value={0}>New Group</option>
                                        {this.state.groups.map(group => (
                                            <option key={group.ID} value={group.ID}>{group.Grouping}</option>
                                        ))}
                                    </Input>
                                </Col>
                            </Row>
                            {this.state.selectedGroup > 0 && <Row>
                                <Col className="scrollVPanel">
                                    <ul>
                                        {this.state.groups.filter(group => group.ID === this.state.selectedGroup)[0].Companies != null &&
                                            this.state.groups.filter(group => group.ID === this.state.selectedGroup)[0].Companies.map(company => (
                                                <li>{company['Primary Business Name']}</li>
                                            ))}
                                    </ul>
                                </Col>
                            </Row>
                            }
                            {this.state.selectedGroup === 0 && <>
                                <Row className='mb-3'>
                                    <Col>
                                        <FormGroup>
                                            <Label>New Group Name</Label>
                                        </FormGroup>
                                        <Input
                                            name="name"
                                            onChange={this.onNewGroupChange}
                                            value={this.state.newGroup.name}
                                        />
                                    </Col>
                                </Row>
                                <Row className='mb-3'>
                                    <Col>
                                        <FormGroup>
                                            <Label>New Group Description</Label>
                                        </FormGroup>
                                        <Input
                                            name="description"
                                            onChange={this.onNewGroupChange}
                                            value={this.state.newGroup.description}
                                        />
                                    </Col>
                                </Row>
                                <Row className='pb-3 mb-3'>
                                    <Col>
                                        <FormGroup>
                                            <Label>Private?</Label>
                                        </FormGroup>
                                        <Input
                                            name="private"
                                            type="checkbox"
                                            className='ml-2'
                                            onChange={this.onNewGroupChange}
                                            checked={this.state.newGroup.private}
                                        />
                                    </Col>
                                </Row></>
                            }
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="secondary"
                                onClick={() => this.setState({ showModal: false })}
                            >
                                Cancel
                            </Button>
                            <Button
                                color="primary"
                                disabled={this.state.selectedGroup === -1 || (this.state.selectedGroup === 0 && this.state.newGroup.name === '')}
                                onClick={this.handleGroupSave}
                            >
                                Save
                            </Button>
                        </ModalFooter>
                    </>
                    }


                </Modal >
                <Row>
                    <Col>
                        <Input
                            type="select"
                            disabled={this.props.selected.length === 0}
                            onChange={(e) => {
                                if (this.state.users.length === 0) {
                                    this.getUsers();
                                    // // this.getMarketingCampaigns();
                                    this.getMarketing2Campaigns();
                                }
                                this.setState({ selectedAction: parseInt(e.target.value) })
                            }
                            }
                            value={parseInt(this.state.selectedAction)}
                        >
                            <option value={0}>Action</option>
                            {this.props.selected.length > 0 && this.actions.map(action => (
                                <option key={action.value} value={action.value}>{action.label}</option>
                            ))}
                        </Input>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Button
                            color="primary"
                            className="my-4"
                            onClick={this.handleApplyToSelected}
                            disabled={this.props.selected.length === 0 || this.state.selectedAction === 0}
                        >
                            Apply to Selected {this.props.selected.length > 0 && `(${this.props.selected.length})`}
                        </Button>
                    </Col>
                </Row>
            </>
        )

    }
}

export default Groupings;
